import React, { useState } from "react";
import { upsertUseCase } from "../../../usecases/object";
import { useNavigate } from "react-router-dom";

export default function NotificationContents({ objects }) {
  const navigate = useNavigate();
  const [displayCount, setDisplayCount] = useState(10);

  const handleMarkAsRead = async (notification) => {
    await upsertUseCase().execute("notifications", {
      id: notification.id,
      isRead: true,
    });
  };

  const handleMarkAsUnread = async (notification) => {
    await upsertUseCase().execute("notifications", {
      id: notification.id,
      isRead: false,
    });
  };

  const handleNotificationClick = async (notification) => {
    if (notification.redirectTo) {
      await upsertUseCase().execute("notifications", {
        id: notification.id,
        isRead: true,
      });
      navigate(`/${notification.redirectTo}`);
    }
  };

  const handleViewMore = () => {
    setDisplayCount((prevCount) => prevCount + 10);
  };

  const displayedNotifications = objects?.slice(0, displayCount);

  return (
    <div
      className="d-flex flex-column h-100 flex-grow-1"
      style={{
        minHeight: "10rem",
        maxHeight: "20rem",
        minWidth: "20rem",
        maxWidth: "30rem",
        position: "relative",
        overflowY: "auto",
      }}
    >
      {displayedNotifications?.map((notification, index) => (
        <div
          key={index}
          className={`p-3 border-bottom ${
            !notification.isRead ? "bg-light" : ""
          }`}
          onClick={() => handleNotificationClick(notification)}
          style={{ cursor: notification.redirectTo ? "pointer" : "default" }}
        >
          <div className="d-flex justify-content-between align-items-start">
            <p className="mb-1" style={{ fontSize: "0.9rem" }}>
              {notification.message}
            </p>
            <div
              className="position-relative"
              title={notification.isRead ? "Mark as unread" : "Mark as read"}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() =>
                  notification.isRead
                    ? handleMarkAsUnread(notification)
                    : handleMarkAsRead(notification)
                }
                className="btn btn-link p-0 ms-2"
              >
                <i
                  className={`bi ${
                    notification.isRead ? "bi-envelope" : "bi-envelope-open"
                  }`}
                  style={{ fontSize: "1rem" }}
                ></i>
              </button>
            </div>
          </div>
          <small className="text-muted">
            {new Date(notification.createdAt).toLocaleString()}
          </small>
        </div>
      ))}
      {objects?.length > displayCount && (
        <button
          className="text-primary bg-transparent fs-6 border-0 align-self-end mt-2"
          onClick={handleViewMore}
        >
          View more
        </button>
      )}
    </div>
  );
}
